import { Table, Badge, Text, Anchor, Card, Group, Stack } from '@mantine/core'
import { jobApplicationStatusColor } from '../lib/jobApplicationStatusColors'

// #1120 応募状況一覧(/applications)。行データは Rails 側で組み立てて props で受け取り、ここでは描画のみ。
// variant: 'expert' = 自分の応募(企業列) / 'client' = 自社案件への応募(応募者列)。
// #1121 応募詳細(タイムライン・面談予定)へは row.jobApplicationHref でリンクする。辞退は 2-3 で追加する。
// #1234 sm 未満はテーブルではなくカードのスタック表示にする(横スクロール前提の表をモバイルに出さない)。
const EMPTY_MESSAGE = {
  expert: '応募した案件はまだありません。',
  client: '自社案件への応募はまだありません。',
}

function PositionCell({ row }) {
  if (!row.positionHref) return row.positionTitle
  return <Anchor href={row.positionHref} fw={500}>{row.positionTitle}</Anchor>
}

function JobApplicationRowCard({ row, isClient }) {
  return (
    <Card component="a" href={row.jobApplicationHref} withBorder radius="md" padding="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap" mb={4}>
        <Text fw={500} lineClamp={2} style={{ flex: 1 }}>{row.positionTitle}</Text>
        <Badge color={jobApplicationStatusColor(row.status)} variant="light" radius="sm">
          {row.statusLabel}
        </Badge>
      </Group>
      <Text size="sm" c="dimmed" lineClamp={1} mb="xs">
        {isClient
          ? (row.applicantName || '(退会ユーザー)')
          : row.companyName}
      </Text>
      <Group justify="space-between" gap="xs">
        <Text size="xs" c="dimmed">応募日 {row.appliedAt}</Text>
        <Text size="xs" c="dimmed">最終更新 {row.updatedAt}</Text>
      </Group>
    </Card>
  )
}

export default function JobApplicationList({ variant = 'expert', rows = [] }) {
  const isClient = variant === 'client'

  if (rows.length === 0) {
    return <Text c="dimmed" py="xl" ta="center">{EMPTY_MESSAGE[variant] || EMPTY_MESSAGE.expert}</Text>
  }

  return (
    <>
      <Table.ScrollContainer minWidth={680} visibleFrom="sm">
        <Table striped highlightOnHover withTableBorder verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>案件</Table.Th>
              <Table.Th>{isClient ? '応募者' : '企業'}</Table.Th>
              <Table.Th w={110}>応募日</Table.Th>
              <Table.Th w={110}>ステータス</Table.Th>
              <Table.Th w={150}>最終更新</Table.Th>
              <Table.Th w={70} />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.id}>
                <Table.Td><PositionCell row={row} /></Table.Td>
                <Table.Td>
                  {isClient
                    ? (row.applicantName || <Text c="dimmed" span>(退会ユーザー)</Text>)
                    : row.companyName}
                </Table.Td>
                <Table.Td>{row.appliedAt}</Table.Td>
                <Table.Td>
                  <Badge color={jobApplicationStatusColor(row.status)} variant="light" radius="sm">
                    {row.statusLabel}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  <Text fz="sm" c="dimmed">{row.updatedAt}</Text>
                </Table.Td>
                <Table.Td>
                  <Anchor href={row.jobApplicationHref} fz="sm">詳細</Anchor>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>

      <Stack gap="sm" hiddenFrom="sm">
        {rows.map((row) => (
          <JobApplicationRowCard key={row.id} row={row} isClient={isClient} />
        ))}
      </Stack>
    </>
  )
}
